import React, { Component } from "react";
import DataTable from "../../../PortfolioDashboard/navigationPages/Datatable/DataTable";
import PieContainer from "./pieContainer";
import SolutionHelper from './solution.helper';

class PieHolder extends Component {
  state = {
    newData: [],
    newPieData: [],
    columns: [
      { title: "Symbol" },
      { title: "Name" },
      { title: "Asset Class" },
      { title: "Weight(%)" }
    ]
  };
  componentDidMount() {
    if (this.props.getBacktest) {
      // let getPortfolioData = this.props.getBacktest.getPortfolioData;
      // let portfolioFilter = [];
      // let portfolioData = {};
      // let PieData = [];

      // for (let i in getPortfolioData) {
      //   let line = getPortfolioData[i];
      //   if (
      //     i == 0 ||
      //     (portfolioFilter[portfolioFilter.length - 1] &&
      //       portfolioFilter[portfolioFilter.length - 1].value != line.dt)
      //   ) {
      //     portfolioFilter.push({
      //       value: line.dt
      //     });
      //   }

      //   line.dt in portfolioData
      //     ? portfolioData[line.dt].push([
      //         line.symbol,
      //         line.fund_name,
      //         line.fund_asset_class_focus,
      //         line.allocation,
      //         line.style
      //       ])
      //     : (portfolioData[line.dt] = [
      //         [
      //           line.symbol,
      //           line.fund_name,
      //           line.fund_asset_class_focus,
      //           line.allocation,
      //           line.style
      //         ]
      //       ]);

      //   line.dt in PieData
      //     ? PieData[line.dt].push({
      //         fund: line.fund_asset_class_focus,
      //         allocation: line.allocation * 1,
      //         style: line.style
      //       })
      //     : (PieData[line.dt] = [
      //         {
      //           fund: line.fund_asset_class_focus,
      //           allocation: line.allocation * 1,
      //           style: line.style
      //         }
      //       ]);
      // }
      // let newData = [];
      // let newPieData = [];

      // if (portfolioFilter.length > 0 && this.state.newData == 0) {
      //   newData =
      //     portfolioData[portfolioFilter[portfolioFilter.length - 1].value];
      // }
      // if (portfolioFilter.length > 0 && this.state.newPieData == 0) {
      //   newPieData = PieData[portfolioFilter[portfolioFilter.length - 1].value];
      // }

      var data = SolutionHelper.pieTableHelper(this.props);
      let newData = data[0];
      let newPieData = data[1];
      this.setState({
        newData,
        newPieData
      });
    }
  }
  render() {
    const { columns, newPieData, newData } = this.state;
    return (
      <div className="row">
        <div className="col-lg-6 col-md-6 col-sm-12 col-xs-12">
        <h4 className="text-uppercase bold">Holdings and asset class exposure  </h4>
          {newPieData.length > 0 ? (
            <PieContainer newPieData={newPieData} />
          ) : null}
        </div>
        <div className="col-lg-6 col-md-6 col-sm-12 col-xs-12">
          {newData.length > 0 ? (
            <DataTable
              data={newData}
              columns={columns}
              paging={true}
              searching={false}
            />
          ) : null}
        </div>
      </div>
    );
  }
}
export default PieHolder;



// WEBPACK FOOTER //
// ./src/components/pages/Retire/solution/pieHolder.jsx